function initHeroParallaxGSAP() {
  if (typeof gsap === 'undefined') return;
  
  gsap.registerPlugin(ScrollTrigger);
  
  const heroSections = document.querySelectorAll('[id*="__hero"]');
  
  heroSections.forEach((hero, index) => {
    const bgImage = hero.querySelector('img');
    
    if (!bgImage) return;
    
    console.log(`Creo animazione per Hero ${index}`);
    
    // Imposta posizione iniziale PRIMA dell'animazione
    gsap.set(bgImage, {
      yPercent: -15,
      scale: 1.15,
      force3D: true
    });
    
    gsap.to(bgImage, {
      yPercent: 15, // Da -15 a +15 = 30% di movimento totale
      ease: 'none',
      force3D: true,
      scrollTrigger: {
        trigger: hero,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1.5, // Leggermente più reattivo
        invalidateOnRefresh: true
      }
    });
  });
}

// Rimuovi il setTimeout - esegui subito
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroParallaxGSAP);
} else {
  initHeroParallaxGSAP();
}
